<template>
<div class="col-12" v-if="outcome">
<span class="mr-2">
Çıktıyı
</span>
<Dropdown 
:filter="false"  
v-model="outcome.comparison_type" 
:options="comparison_types" 
optionLabel="name" 
optionValue="code" 
class="ml-2 p-inputtext-sm mt-2" 
/>

<template v-if="outcome.comparison_type">
	<!-- input -->
	<template v-if="outcome.comparison_type=='input'">
		<Dropdown 
		:filter="false"  
		v-model="outcome.comparison_input" 
		:options="inputs" 
		optionLabel="name" 
		optionValue="stack_id" 
		class="ml-2 p-inputtext-sm mt-2 w-4" 
		/>

		<span class="ml-2" v-if="outcome.comparison_input">
		olarak belirle.
		</span>
		
	</template>
	<!-- input -->

	<!-- value -->
	<template v-if="outcome.comparison_type=='value'">
	<Dropdown 
	:filter="false"  
	v-model="outcome.output_type" 
	:options="value_types" 
	optionLabel="name" 
	optionValue="code" 
	class="ml-2 p-inputtext-sm mt-2" 
	/>
	<template v-if="outcome.output_type=='numerical' || outcome.output_type=='textual'">
		<InputNumber v-if="outcome.output_type=='numerical'" placeholder="Sayısal değer"  v-model="outcome.numerical_val" class="ml-2 p-inputtext-sm mt-2" />
		<InputText v-if="outcome.output_type=='textual'" type="text" placeholder="Text değeri"  v-model="outcome.text_val" class="ml-2 p-inputtext-sm mt-2" />	

	</template>

	<span class="ml-2" v-if="outcome.numerical_val || outcome.text_val">
		olarak belirle.
		</span>

	</template>
	<!-- value -->

	

		
		

	

	



</template>



</div>
</template>

<script>
export default {

  name: 'LogicBundleOutcomeLine',
  props:["theoutcome","inputs"],
  data () {
    return {
    	outcome:null,
    	comparison_types:[
    	{name:"Veri",code:"input"},
    	{name:"Tam Değer",code:"value"},
    	],
    	value_types:[
    	{name:"Sayısal",code:"numerical"},
    	{name:"Text",code:"textual"},
    	],
    }
  },
  mounted()
  {
  	this.outcome = this.theoutcome
  },
  methods:{

  }
}
</script>

<style lang="css" scoped>
</style>
